// Action Types
export const FETCH_QUESTION_PROMPTER_REQUEST = "FETCH_QUESTION_PROMPTER_REQUEST";
export const FETCH_QUESTION_PROMPTER_SUCCESS = "FETCH_QUESTION_PROMPTER_SUCCESS";
export const FETCH_QUESTION_PROMPTER_FAILURE = "FETCH_QUESTION_PROMPTER_FAILURE";
// Action Creators
export const fetchQuestionPrompterRequest = (data) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_QUESTION_PROMPTER_REQUEST,
      payload: data,
    });
  };
};
export const fetchQuestionPrompterSuccess = (payload) => ({
  type: FETCH_QUESTION_PROMPTER_SUCCESS,
  payload,
});
export const fetchQuestionPrompterFailure = (error) => ({
  type: FETCH_QUESTION_PROMPTER_FAILURE,
  payload: error,
});
